export const schedulingEn = {
  scheduling: 'Scheduling',
  pollIntro: 'Find a time that works for everyone, including guests outside the platform.',
  pollNew: 'New poll',
  pollEmpty: 'Find your next meeting time',
  pollEmptyHint: 'Propose a few times, share the link, and let everyone mark their availability.',
  pollTitle: 'Meeting title',
  pollDescription: 'Description (optional)',
  pollLocation: 'Location or meeting link (optional)',
  pollDuration: 'Duration in minutes',
  pollOptions: 'Proposed times',
  pollCreateZone: 'Enter times in {zone}. Guests see them in their own time zone. You can propose 2–40 times.',
  pollOptionNumber: 'Option {count}',
  pollRemoveOption: 'Remove option {count}',
  pollAddOption: 'Add a time',
  pollCreate: 'Create poll',
  pollInvalidTimes: 'Choose valid future times and a duration of 1–1440 minutes. Times skipped by daylight saving changes cannot be used.',
  pollDuplicateTimes: 'Choose different start times for each option.',
  pollPublicNotice: 'Anyone with the link can see the meeting details, your name, and all responses, and can vote without an account. Share only information intended for these guests. Do not include patient information.',
  pollResponses: '{count} responses',
  pollResponses_one: '1 response',
  pollYouOrganize: 'You organize this poll',
  pollOpen: 'Open for voting',
  pollClosed: 'Closed',
  pollConfirmed: 'Time confirmed',
  pollMeeting: 'Meeting poll',
  pollOrganizer: 'Organized by {name}',
  pollWhere: 'Location',
  pollShare: 'Invite participants',
  pollLink: 'Shareable link',
  pollGuestView: 'Open the shared poll',
  pollManage: 'Manage this poll',
  pollTimezone: 'Times shown in',
  pollFinalHint: 'The organizer has chosen this time. Voting is closed.',
  pollClosedHint: 'Voting is closed. No meeting time has been chosen.',
  pollYourAvailability: 'When can you join?',
  pollEditResponse: 'Your availability',
  pollVotingAs: 'Voting as {name}',
  pollYourName: 'Your name',
  pollVoteHint: 'Choose Yes, Maybe, or No for every time, then save your response.',
  pollChoice_yes: 'Yes',
  pollChoice_maybe: 'Maybe',
  pollChoice_no: 'No',
  pollVotePrivacy: 'Your name and availability are visible to everyone with this link.',
  pollGuestEdits: 'A cookie lets you edit or withdraw your response in this browser. Keep using this browser; clearing cookies removes that access.',
  pollSaveResponse: 'Save response',
  pollSaved: 'Your response is saved. You can change it while voting is open.',
  pollWithdraw: 'Withdraw response',
  pollResults: 'Everyone’s availability',
  pollNoResponses: 'No responses yet. Share the link to start finding a time.',
  pollParticipant: 'Participant',
  pollYou: 'You',
  pollGuest: 'Guest · name not verified',
  pollBest: 'Most available',
  pollAvailable: 'Available',
  pollOrganize: 'Choose the meeting time',
  pollFinalizeHint: 'Confirm one of the proposed times to close voting. You can reopen the poll if plans change.',
  pollFinalTime: 'Final meeting time',
  pollChooseTime: 'Choose a proposed time',
  pollConfirmTime: 'Confirm time and close voting',
  pollClose: 'Close without choosing a time',
  pollReopen: 'Reopen voting',
  pollDelete: 'Delete poll',
  pollDeleteWarning: 'Delete the poll and every response? The shared link will stop working.',
  pollCreateOwn: 'Create your own poll · sign in',
  pollPrivacy: 'Privacy notice',
  pollNext: 'More polls',
}

export const schedulingDe: Record<keyof typeof schedulingEn, string> = {
  scheduling: 'Terminfindung',
  pollIntro: 'Finden Sie einen gemeinsamen Termin, auch mit Gästen außerhalb der Plattform.',
  pollNew: 'Neue Umfrage',
  pollEmpty: 'Finden Sie den nächsten Besprechungstermin',
  pollEmptyHint: 'Schlagen Sie Termine vor, teilen Sie den Link und lassen Sie alle ihre Verfügbarkeit angeben.',
  pollTitle: 'Titel der Besprechung',
  pollDescription: 'Beschreibung (optional)',
  pollLocation: 'Ort oder Besprechungslink (optional)',
  pollDuration: 'Dauer in Minuten',
  pollOptions: 'Terminvorschläge',
  pollCreateZone: 'Geben Sie Zeiten in {zone} ein. Gäste sehen sie in ihrer eigenen Zeitzone. Sie können 2–40 Termine vorschlagen.',
  pollOptionNumber: 'Vorschlag {count}',
  pollRemoveOption: 'Vorschlag {count} entfernen',
  pollAddOption: 'Termin hinzufügen',
  pollCreate: 'Umfrage erstellen',
  pollInvalidTimes: 'Wählen Sie gültige zukünftige Zeiten und eine Dauer von 1–1440 Minuten. Durch die Zeitumstellung übersprungene Zeiten sind nicht möglich.',
  pollDuplicateTimes: 'Wählen Sie unterschiedliche Anfangszeiten.',
  pollPublicNotice: 'Alle mit dem Link sehen die Besprechungsdetails, Ihren Namen und alle Antworten und können ohne Konto abstimmen. Teilen Sie nur Angaben, die für diese Gäste bestimmt sind. Geben Sie keine Patientendaten an.',
  pollResponses: '{count} Antworten',
  pollResponses_one: '1 Antwort',
  pollYouOrganize: 'Sie organisieren diese Umfrage',
  pollOpen: 'Abstimmung offen',
  pollClosed: 'Geschlossen',
  pollConfirmed: 'Termin bestätigt',
  pollMeeting: 'Terminumfrage',
  pollOrganizer: 'Organisiert von {name}',
  pollWhere: 'Ort',
  pollShare: 'Teilnehmende einladen',
  pollLink: 'Link zum Teilen',
  pollGuestView: 'Geteilte Umfrage öffnen',
  pollManage: 'Umfrage verwalten',
  pollTimezone: 'Zeiten angezeigt in',
  pollFinalHint: 'Dieser Termin wurde festgelegt. Die Abstimmung ist geschlossen.',
  pollClosedHint: 'Die Abstimmung ist geschlossen. Es wurde kein Termin festgelegt.',
  pollYourAvailability: 'Wann können Sie teilnehmen?',
  pollEditResponse: 'Ihre Verfügbarkeit',
  pollVotingAs: 'Sie stimmen als {name} ab',
  pollYourName: 'Ihr Name',
  pollVoteHint: 'Wählen Sie für jeden Termin Ja, Vielleicht oder Nein und speichern Sie Ihre Antwort.',
  pollChoice_yes: 'Ja',
  pollChoice_maybe: 'Vielleicht',
  pollChoice_no: 'Nein',
  pollVotePrivacy: 'Ihr Name und Ihre Verfügbarkeit sind für alle mit diesem Link sichtbar.',
  pollGuestEdits: 'Ein Cookie ermöglicht es, Ihre Antwort in diesem Browser zu ändern oder zurückzuziehen. Verwenden Sie weiter diesen Browser; beim Löschen der Cookies geht dieser Zugang verloren.',
  pollSaveResponse: 'Antwort speichern',
  pollSaved: 'Ihre Antwort ist gespeichert. Solange die Abstimmung offen ist, können Sie sie ändern.',
  pollWithdraw: 'Antwort zurückziehen',
  pollResults: 'Verfügbarkeit aller Teilnehmenden',
  pollNoResponses: 'Noch keine Antworten. Teilen Sie den Link, um einen Termin zu finden.',
  pollParticipant: 'Teilnehmende',
  pollYou: 'Sie',
  pollGuest: 'Gast · Name nicht überprüft',
  pollBest: 'Meiste Zusagen',
  pollAvailable: 'Verfügbar',
  pollOrganize: 'Besprechungstermin festlegen',
  pollFinalizeHint: 'Bestätigen Sie einen Vorschlag, um die Abstimmung zu schließen. Bei Änderungen können Sie sie wieder öffnen.',
  pollFinalTime: 'Endgültiger Besprechungstermin',
  pollChooseTime: 'Einen Vorschlag wählen',
  pollConfirmTime: 'Termin bestätigen und Abstimmung schließen',
  pollClose: 'Ohne Termin schließen',
  pollReopen: 'Abstimmung wieder öffnen',
  pollDelete: 'Umfrage löschen',
  pollDeleteWarning: 'Die Umfrage und alle Antworten löschen? Der geteilte Link funktioniert danach nicht mehr.',
  pollCreateOwn: 'Eigene Umfrage erstellen · anmelden',
  pollPrivacy: 'Datenschutzhinweise',
  pollNext: 'Weitere Umfragen',
}
